import React from "react";

import { FormattedMessage } from "react-intl";

import noAccess from "@app/assets/list/preview/no-access.svg";

import styles from "./NoAccess.module.scss";

interface Props {}

const NoAccess: React.FC<Props> = () => {
  return (
    <section className={styles.noAccess}>
      <div>
        <img alt="No access" className={styles.noAccessImage} src={noAccess} />
        <div className={styles.noAccessTitle}>
          <FormattedMessage
            id="recordPane.noAccess.title"
            defaultMessage="Record not found"
            description="Title of no access to preview section of the record pane"
          />
        </div>
        <div className={styles.noAccessDescription}>
          <FormattedMessage
            id="recordPane.noAccess.description"
            defaultMessage="You don’t have access to this record or it may have been deleted"
            description="Description of no access to preview section of the record pane."
          />
        </div>
      </div>
    </section>
  );
};

export default NoAccess;
